// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wsjfs","content":"styles_content__19D31","tableWrap":"styles_tableWrap__24Roy"};